/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * メディアリストを保存した時の操作ログとして記録する内容
 * @export
 * @interface SavedMediaListOperationLog
 */
export interface SavedMediaListOperationLog {
    /**
     * メディアリストに対する操作の種類
     * @type {string}
     * @memberof SavedMediaListOperationLog
     */
    actionType: string;
    /**
     * メディアリスト名
     * @type {string}
     * @memberof SavedMediaListOperationLog
     */
    mediaListName: string;
    /**
     * 送信者名
     * @type {string}
     * @memberof SavedMediaListOperationLog
     */
    senderName: string;
    /**
     * メディアのIDリスト
     * @type {Array<number>}
     * @memberof SavedMediaListOperationLog
     */
    mediaOutletIds: Array<number>;
}

export function SavedMediaListOperationLogFromJSON(json: any): SavedMediaListOperationLog {
    return SavedMediaListOperationLogFromJSONTyped(json, false);
}

export function SavedMediaListOperationLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavedMediaListOperationLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actionType': json['action_type'],
        'mediaListName': json['media_list_name'],
        'senderName': json['sender_name'],
        'mediaOutletIds': json['media_outlet_ids'],
    };
}

export function SavedMediaListOperationLogToJSON(value?: SavedMediaListOperationLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action_type': value.actionType,
        'media_list_name': value.mediaListName,
        'sender_name': value.senderName,
        'media_outlet_ids': value.mediaOutletIds,
    };
}

